import Super from '../../core/button.gjs';
import styles from './negative.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Negative',
  description: `
    Negative button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Negative Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/negative.gjs',
  },
};

export default class SpdsActionButtonNegative extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-negative';
  variantStyles = styles;
}

export const ACTION_BUTTON_NEGATIVE_METADATA = SpdsActionButtonNegative.metadata;
